
const leadershipContent = 
    [
        {
            "company": "Ramapo College Office of Residence Life",
            "location": "Mahwah, NJ",
            "duration": "Aug 2019 - May 2022",
            "extra": "",
            "roles": [

                {
                    "title": "Resident Assistant",
                    "description": [
                        "At Ramapo College, I embraced the role of a leader within the college community, where I developed over 15 programs aimed at developing community within my residence hall. My responsibilities ranged from performing administrative tasks to providing critical support during crisis situations on duty nights. This role strengthened my abilities to collaborate effectively with diverse groups and build inclusive environments.",
                        "In my position at Ramapo College, I significantly enhanced my organizational skills and ability to collaborate within large teams, including working closely with college directors. I took the lead in orchestrating community-building programs that brought together diverse groups, fostering a sense of unity and cooperation. This role not only sharpened my project management abilities but also deepened my expertise in creating and nurturing a vibrant community, demonstrating my capacity to innovate and lead in dynamic environments."                        
                    ],
                },
                {
                    "title": "Student Assistant Resident Director",
                    "description": [
                        "Between January 2021 - May 2021, I was chosen to work as a Senior Assistant Resident Director, leading a team of nine Resident Assistants. This role required close collaboration with college directors and improved my leadership skills under pressure. I navigated the team through the tasks of pandemic management, emphasizing safety and support. My time as a SARD exemplified my ability to lead decisively and compassionately in times of stress and change."
                    ],
                }
            ],
            "skills": [
                { "text": "Project Management" },         
            ]
        },
        {
            "company": "WRPR-FM",
            "location": "Ramapo College of New Jersey",
            "duration": "Sep 2019 - May 2022",
            "roles": [
                {
                    "title": "President",
                    "description": [
                        "As President of the campus radio station, I oversaw all radio shows and was responsible for the setup and hosting of numerous campus events that required expert handling of music and sound systems. My role extended beyond management to ensuring that our station's equipment was always operational and up to professional standards. I also dedicated myself to training new members, equipping them with the necessary skills to operate our complex audio equipment, thus fostering a knowledgeable and enthusiastic next generation of radio personnel."
                    ]
                }
            ],
            "skills": [
   
            ]
        },

    ]

export default leadershipContent;
